module.exports = __webpack_public_path__ + "static/media/prophet_model.36fd7414.gif";